<template>
  <div class="content content1 clearfix">
      <div class="aboutUs fl">
        <p class="nav">#<span>认识我们</span></p>
        <p class="title">领先市场的风险投资与股权投资的专业平台</p>
        <p class="cont">
          亚商资本是<a href="https://www.abc-group.cn/" style="color:#373737;" target="_blank">亚商集团</a>的股权投资平台，也是中国最早从事风险投资和股权投资的专业投资机构。亚商资本专注高成长行业的创业者和具备快增长潜力的成长型企业，自2000年至今前后共设立并管理十多只基金，七十多亿人民币。专注对创业早期和成长型企业的投资和增值服务。在国内主要经济中心城市设有分支机构和子基金，并和各地政府引导基金合作，深耕当地企业。
        </p>
        <div class="bg">
            <p class="eightteen"><img src="../../assets/18years.png" alt=""></p>
            <p class="logo"><img src="../../assets/logo.png" alt=""></p>
        </div>
      </div>
      <div class="aboutPic fr"><img src="../../assets/18pic.png" alt=""></div>
   </div>
</template>

<script>
export default {
  name: 'KnowUs',
  data(){
      return {

      }
  }
}
</script>
<style scoped>
.content1 .aboutUs{
  /* width: 525px; */
  width: 46%;
}
.content1 .aboutUs .bg{
    padding-bottom: 20px;
    background: url('./knowus_bgl.png') no-repeat 54px 20px;
}
.content1 .aboutPic{
    width: 50%;
    text-align: right;
    padding-bottom: 50px;
    background: url('./knowus_bgr.png') no-repeat left bottom;
}
.content1{
  padding: 138px 120px 0px 174px;
  max-width: 1520px;
  min-width: 1200px;
  box-sizing: border-box;
  margin-bottom: 120px;
}
.content .nav{
  font-size: 24px;
  color: #c70016;
  font-weight: 600;
  margin-bottom: 30px;
}
.content .nav span{
  font-weight: 600;
  color: #333367;
}
.content .title{
  font-size: 36px;
  color: #343062;
  line-height: 42px;
  /* font-weight: 600; */
  margin-bottom: 48px;
}
.content .cont{
  color: #373737;
  line-height: 24px;
}
.content .eightteen{
  margin: 48px 0;
  text-align: left;
}
.content .logo{
   margin-left: 150px;
}
</style>




// WEBPACK FOOTER //
// src/components/knowUs/knowUs.vue